import {
GET_PRODUCTION_REASON_REPORT_REQUEST,
GET_PRODUCTION_REASON_REPORT_SUCCESS,
GET_PRODUCTION_REASON_REPORT_ERROR
} from "../actions/types";

export const productionReason = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_PRODUCTION_REASON_REPORT_REQUEST:
      return {
        loading: true,
      };
    case GET_PRODUCTION_REASON_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_PRODUCTION_REASON_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};
